const trackSegmentEvent = (type, message, data = null) => {
  // only track events on live website
  if (window.location.hostname.indexOf("logology.co") > -1) {
    if (window && window.analytics) window.analytics[type](message, data)
  }
}

export { trackSegmentEvent }
